import { 
  Container, 
  Row, 
  Col, 
  Card, 
  CardBody, 
  CardHeader
} from "reactstrap";
import MainLayout from "../../layouts/MainLayout";

function TermsPage() {
  return (
    <MainLayout>
      <section className="py-5 bg-light" dir="rtl">
        <Container>
          <Row className="justify-content-center">
            <Col lg="10" md="12">
              <div className="text-center mb-5">
                <h1 className="mb-3">شروط الاستخدام</h1>
                <p className="lead text-muted">
                  يرجى قراءة هذه الشروط بعناية قبل استخدام خدماتنا
                </p>
              </div>
              
              <Card className="border-0">
                <CardHeader className="bg-primary text-white">
                  <h3 className="mb-0">شروط وأحكام الاستخدام</h3>
                </CardHeader>
                <CardBody className="p-4">
                  <div className="terms-content">

                    <div className="mb-4">
                      <h4 className="text-primary mb-3">1. قبول الشروط</h4>
                      <p className="text-justify">
                        مرحباً بك في مشنص. من خلال الوصول إلى موقعنا أو استخدام خدماتنا، فإنك توافق على الالتزام بهذه الشروط والأحكام. إذا كنت لا توافق على أي من هذه البنود، يُرجى التوقف عن استخدام خدماتنا.
                      </p>
                    </div>

                    <div className="mb-4">
                      <h4 className="text-primary mb-3">2. تعريف المصطلحات</h4>
                      <ul className="text-justify">
                        <li><strong>الخدمة:</strong> تشير إلى موقع وتطبيق مشنص وجميع الخدمات المقدمة من خلالهما.</li>
                        <li><strong>المستخدم:</strong> أي شخص يستخدم خدمات مشنص سواء كزائر أو عضو مسجّل.</li>
                        <li><strong>المحتوى:</strong> جميع النصوص والصور والبيانات والمعلومات المعروضة على المنصة.</li>
                        <li><strong>الحساب:</strong> حساب المستخدم المسجل في المنصة.</li>
                      </ul>
                    </div>

                    <div className="mb-4">
                      <h4 className="text-primary mb-3">3. أهلية الاستخدام</h4>
                      <p className="text-justify">لاستخدام خدماتنا، يجب أن تكون:</p>
                      <ul className="text-justify">
                        <li>لا تقل عن 18 عاماً أو لديك موافقة وليّ الأمر.</li>
                        <li>تملك الصلاحية القانونية لإبرام اتفاقيات ملزمة.</li>
                        <li>غير محظور من استخدام الخدمات بموجب القوانين الكويتية.</li>
                        <li>تقدم معلومات دقيقة وصحيحة أثناء التسجيل.</li>
                      </ul>
                    </div>

                    <div className="mb-4">
                      <h4 className="text-primary mb-3">4. تسجيل الحساب</h4>
                      <p className="text-justify">عند إنشاء حساب في مشنص، فإنك توافق على:</p>
                      <ul className="text-justify">
                        <li>تقديم معلومات صحيحة ومحدثة.</li>
                        <li>الحفاظ على سرية كلمة المرور الخاصة بك وعدم مشاركتها مع الآخرين.</li>
                        <li>إخطارنا فوراً بأي استخدام غير مصرح به لحسابك.</li>
                        <li>تحديث بياناتك عند الحاجة.</li>
                        <li>مسؤوليتك الكاملة عن جميع الأنشطة التي تتم عبر حسابك.</li>
                      </ul>
                    </div>

                    <div className="mb-4">
                      <h4 className="text-primary mb-3">5. الاستخدام المقبول</h4>
                      <p className="text-justify">تلتزم باستخدام خدمات مشنص للأغراض القانونية فقط، ويُمنع عليك:</p>
                      <ul className="text-justify">
                        <li>مخالفة أي قوانين أو لوائح في دولة الكويت.</li>
                        <li>نشر محتوى مسيء أو مضلل أو مخالف للآداب العامة.</li>
                        <li>محاولة الوصول غير المصرّح به إلى أنظمة المنصة.</li>
                        <li>تعطيل أو التدخل في تشغيل الموقع أو التطبيق.</li>
                        <li>استخدام المنصة لأغراض تجارية أو تسويقية خارج نطاق خدماتها دون إذن.</li>
                        <li>انتهاك حقوق الملكية الفكرية أو الخصوصية لأي طرف آخر.</li>
                      </ul>
                    </div>

                    <div className="mb-4">
                      <h4 className="text-primary mb-3">6. الملكية الفكرية</h4>
                      <p className="text-justify">
                        جميع النصوص والتصاميم والشعارات والصور والبرمجيات في مشنص مملوكة للمنصة ومحميّة بموجب قوانين حقوق الملكية الفكرية. لا يجوز نسخها أو إعادة نشرها أو تعديلها دون إذن كتابي مسبق من إدارة مشنص.
                      </p>
                    </div>

                    <div className="mb-4">
                      <h4 className="text-primary mb-3">7. المحتوى المقدم من المستخدمين</h4>
                      <p className="text-justify">عند تقديم أي محتوى في المنصة، فإنك:</p>
                      <ul className="text-justify">
                        <li>تمنح مشنص ترخيصاً غير حصري لاستخدامه لغرض العرض والتشغيل ضمن الخدمة.</li>
                        <li>تؤكد أن المحتوى لا ينتهك أي حقوق لطرف آخر.</li>
                        <li>تتحمل المسؤولية الكاملة عن دقة وصحة المحتوى.</li>
                        <li>تقر بحق المنصة في حذف أو تعديل أي محتوى مخالف أو مضلل.</li>
                      </ul>
                    </div>

                    <div className="mb-4">
                      <h4 className="text-primary mb-3">8. التعاملات بين المستخدمين</h4>
                      <p className="text-justify">
                        مشنص منصة لعرض الإعلانات والتواصل فقط، ولا تمثل المنصة أي طرف في المعاملات العقارية (بيع، إيجار، بدل). أي تعامل أو دفع يتم بين المستخدمين يكون على مسؤوليتهم الشخصية، وتوصي المنصة بالتأكد من صحة العقار والعقد قبل دفع أي مبالغ.
                      </p>
                    </div>

                    <div className="mb-4">
                      <h4 className="text-primary mb-3">9. الخدمات المدفوعة (إن وجدت)</h4>
                      <ul className="text-justify">
                        <li>جميع الرسوم تُدفع مقدماً.</li>
                        <li>الأسعار قابلة للتغيير.</li>
                        <li>المبالغ غير قابلة للاسترداد إلا إذا تم النص على ذلك صراحةً.</li>
                        <li>في حال عدم الدفع، يحق للمنصة تعليق الخدمة أو إيقافها.</li>
                      </ul>
                    </div>

                    <div className="mb-4">
                      <h4 className="text-primary mb-3">10. الإنهاء أو التعليق</h4>
                      <p className="text-justify">
                        يحق لمشنص تعليق أو إيقاف حسابك في أي وقت دون إشعار مسبق في حال مخالفة الشروط أو القوانين. كما يمكنك إيقاف حسابك متى شئت عبر التواصل مع الدعم الفني.
                      </p>
                    </div>

                    <div className="mb-4">
                      <h4 className="text-primary mb-3">11. إخلاء المسؤولية</h4>
                      <p className="text-justify">
                        خدمات مشنص تُقدَّم “كما هي” و“حسب الإتاحة”. لا تضمن المنصة دقّة أو اكتمال المعلومات أو موثوقية أي محتوى منشور. استخدامك للخدمة على مسؤوليتك الخاصة بالكامل.
                      </p>
                    </div>

                    <div className="mb-4">
                      <h4 className="text-primary mb-3">12. تحديد المسؤولية</h4>
                      <p className="text-justify">
                        لن تكون مشنص مسؤولة عن أي أضرار مباشرة أو غير مباشرة أو تبعية أو خسائر مالية ناتجة عن استخدامك للخدمة أو اعتمادك على أي محتوى أو معاملة تمت من خلال المنصة.
                      </p>
                    </div>

                    <div className="mb-4">
                      <h4 className="text-primary mb-3">13. التعويض</h4>
                      <p className="text-justify">
                        أنت توافق على تعويض مشنص وإعفائها من أي مطالبات أو خسائر أو تكاليف (بما فيها أتعاب المحاماة) تنتج عن مخالفتك لهذه الشروط أو لأي قانون معمول به.
                      </p>
                    </div>

                    <div className="mb-4">
                      <h4 className="text-primary mb-3">14. القانون والاختصاص القضائي</h4>
                      <p className="text-justify">
                        تخضع هذه الشروط وتفسّر وفقاً لقوانين دولة الكويت. تختص المحاكم الكويتية وحدها بالنظر في أي نزاع ينشأ عن استخدام المنصة أو خدماتها.
                      </p>
                    </div>

                    <div className="mb-4">
                      <h4 className="text-primary mb-3">15. التعديلات</h4>
                      <p className="text-justify">
                        تحتفظ مشنص بالحق في تعديل هذه الشروط في أي وقت. سيتم إخطار المستخدمين بالتغييرات الجوهرية عبر البريد الإلكتروني أو من خلال إشعار داخل التطبيق. استمرارك في استخدام المنصة بعد التعديل يعني موافقتك على الشروط المحدّثة.
                      </p>
                    </div>

                    <div className="mb-4">
                      <h4 className="text-primary mb-3">16. التواصل معنا</h4>
                      <p className="text-justify">
                        لأي استفسارات أو ملاحظات، يمكنك التواصل مع إدارة المنصة عبر:
                      </p>
                      <div className="contact-info bg-light p-3 rounded">
                        <p className="mb-1"><strong>البريد الإلكتروني:</strong> contact@mishnis.net</p>
                        <p className="mb-1"><strong>الهاتف:</strong> <span dir="ltr">+965 50 11 93 33</span> </p>
                      </div>
                    </div>

                    <div className="text-center mt-4 pt-4 border-top">
                      <p className="text-muted">
                        <small>آخر تحديث: {new Date().toLocaleDateString('ar-DZ', { 
                          year: 'numeric', 
                          month: 'long', 
                          day: 'numeric' 
                        })}</small>
                      </p>
                    </div>

                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </section>
    </MainLayout>
  );
}

export default TermsPage;